document.addEventListener('DOMContentLoaded', () => {
  const toggle = document.querySelector('[data-mobile-toggle]');
  const nav = document.querySelector('[data-mobile-nav]');
  if (toggle && nav) {
    toggle.addEventListener('click', () => {
      const open = !nav.hasAttribute('hidden');
      if (open) {
        nav.setAttribute('hidden', '');
        toggle.setAttribute('aria-expanded', 'false');
        toggle.setAttribute('aria-label', 'Open menu');
      } else {
        nav.removeAttribute('hidden');
        toggle.setAttribute('aria-expanded', 'true');
        toggle.setAttribute('aria-label', 'Close menu');
      }
    });
  }

  document.querySelectorAll('[data-faq]').forEach(item => {
    const q = item.querySelector('.faq-q');
    if (q) q.addEventListener('click', () => {
      const isOpen = item.classList.toggle('open');
      q.setAttribute('aria-expanded', String(isOpen));
    });
  });

  const toast = document.getElementById('Toast');
  const showToast = (message) => {
    if (!toast) return;
    toast.textContent = message;
    toast.classList.add('show');
    window.setTimeout(() => toast.classList.remove('show'), 1800);
  };

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  // Brief, hover/click-only confirm state on a button (class removed automatically).
  // Native CSS/SVG implementation — no external animation library.
  const flashConfirm = (btn) => {
    if (!btn || reduceMotion) return;
    btn.classList.add('is-added');
    window.setTimeout(() => btn.classList.remove('is-added'), 900);
  };

  document.querySelectorAll('[data-add-to-cart]').forEach(btn => {
    btn.addEventListener('click', async () => {
      const id = Number(btn.dataset.addToCart);
      try {
        const r = await fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
          method: 'POST',
          headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
          body: JSON.stringify({items: [{id, quantity: 1}]})
        });
        if (!r.ok) throw new Error('Add to cart failed');
        flashConfirm(btn);
        showToast('Added to cart');
        window.setTimeout(() => window.location.reload(), 350);
      } catch (e) {
        window.location.href = '/cart';
      }
    });
  });

  const productRoot = document.querySelector('[data-product-root]');
  if (productRoot) {
    const labels=JSON.parse(document.getElementById('LSLabels')?.textContent||'{}');
    const variants=JSON.parse(productRoot.querySelector('[data-product-variants]').textContent);
    const form=productRoot.querySelector('form[action*="/cart/add"]');
    const choices=[...productRoot.querySelectorAll('[data-choice-index]')];
    const idInput=productRoot.querySelector('[data-variant-id]');
    const add=productRoot.querySelector('[data-main-add]');
    const buy=productRoot.querySelector('[data-buy-now]');
    const stickyAdd=productRoot.querySelector('[data-sticky-add]');
    const money=cents=>new Intl.NumberFormat(document.documentElement.lang||'en-IN',{style:'currency',currency:window.Shopify?.currency?.active||'INR'}).format(cents/100);
    const selected=()=>[...productRoot.querySelectorAll('[data-option-group]')].map(g=>g.querySelector('input:checked')?.value);
    const optionNames=JSON.parse(productRoot.querySelector('[data-option-names]')?.textContent||'[]');
    const stock=JSON.parse(productRoot.querySelector('[data-variant-stock]')?.textContent||'{}');
    const specs=JSON.parse(productRoot.querySelector('[data-variant-details]')?.textContent||'{}');
    const pdpLabels=JSON.parse(productRoot.querySelector('[data-pdp-labels]')?.textContent||'{}');
    const reviewedGalleries=JSON.parse(productRoot.querySelector('[data-reviewed-galleries]')?.textContent||'{}');
    const listingContent=JSON.parse(productRoot.querySelector('[data-variant-listing-content]')?.textContent||'{}');
    let current;
    const update=(changeImage=false)=>{
      const values=selected();current=values.length?variants.find(v=>v.options.every((x,i)=>x===values[i])):variants.find(v=>String(v.id)===idInput.value);
      idInput.value=current?.id||'';
      [add,buy,stickyAdd].forEach(b=>{if(b)b.disabled=!current?.available});
      add.textContent=current?(current.available?labels.add:labels.sold):labels.unavailable;
      if(stickyAdd)stickyAdd.textContent=add.textContent;
      const price=productRoot.querySelector('[data-product-price]');
      price.replaceChildren();
      if(current){price.append(document.createTextNode(money(current.price)));if(current.compare_at_price>current.price){const compare=document.createElement('span');compare.className='compare';compare.textContent=money(current.compare_at_price);const discount=document.createElement('span');discount.className='badge ls-product-discount';discount.textContent=Math.round((current.compare_at_price-current.price)*100/current.compare_at_price)+'% OFF';price.append(' ',compare,discount)}productRoot.querySelector('[data-sticky-price]')?.replaceChildren(document.createTextNode(money(current.price)));}
      else price.textContent=labels.unavailable;
      productRoot.querySelectorAll('[data-option-group]').forEach((g,i)=>g.querySelector('[data-selected-label]').textContent=values[i]||'');
      choices.forEach(radio=>{const i=Number(radio.dataset.choiceIndex);const candidate=variants.find(v=>v.options.every((x,j)=>x===(j===i?radio.value:values[j])));const priceNode=radio.closest('label').querySelector('[data-choice-price]');if(priceNode)priceNode.textContent=candidate?money(candidate.price):labels.unavailable;const cover=reviewedGalleries[String(candidate?.id)]?.[0]||listingContent[candidate?.id]?.gallery_files?.[0];const galleryImage=cover?[...productRoot.querySelectorAll('[data-image-file]')].find(slide=>slide.dataset.imageFile===cover)?.querySelector('img'):null;const optionImage=radio.closest('label').querySelector('img');if(optionImage&&galleryImage){optionImage.src=galleryImage.src;optionImage.srcset=galleryImage.srcset;optionImage.sizes='140px';}radio.closest('label').classList.toggle('ls-choice-unavailable',!candidate?.available)});
      const details=productRoot.querySelector('[data-selected-specs]');
      const content=listingContent[current?.id]||{};
      const summary={...(specs[current?.id]||{})};
      if(content.included_items)summary.included=content.included_items;
      const copy=productRoot.querySelector('[data-variant-copy]');
      if(copy){
        copy.replaceChildren();
        for(const [key,title] of [['description','Product Details'],['features','Key Features'],['specifications','Specifications'],['care','Care Guide']]){
          if(!content[key])continue;
          const panel=document.createElement('details'),heading=document.createElement('summary'),body=document.createElement('div');
          heading.textContent=title;body.className='rte';
          if(key==='description'){
            content[key].split(/\n\s*\n/).forEach(text=>{const paragraph=document.createElement('p');paragraph.textContent=text;body.append(paragraph)});
          }else{
            const list=document.createElement('ul');content[key].split(/\n/).filter(Boolean).forEach(text=>{const item=document.createElement('li');item.textContent=text;list.append(item)});body.append(list);
          }
          panel.append(heading,body);copy.append(panel);
        }
        copy.hidden=!copy.children.length;
        const general=productRoot.querySelector('[data-general-product-copy]');if(general)general.hidden=Boolean(content.description);
      }
      productRoot.querySelectorAll('[data-listing-variant]').forEach(panel=>{
        panel.hidden=panel.dataset.listingVariant!==String(current?.id);
      });
      if(details){
        details.replaceChildren();
        const pair=(name,value)=>{if(!value)return;const dt=document.createElement('dt'),dd=document.createElement('dd');dt.textContent=name;dd.textContent=value;details.append(dt,dd)};
        if(current){optionNames.forEach((name,i)=>pair(name,current.options[i]));pair(pdpLabels.included,summary.included);pair(pdpLabels.sku,current.sku)}
      }
      const entry=stock[current?.id];
      const status=productRoot.querySelector('[data-stock-status]');
      if(status)status.textContent=!current?pdpLabels.unavailable:!current.available?pdpLabels.sold:entry?.tracked&&entry.quantity>0?`${entry.quantity} ${pdpLabels.stock}`:pdpLabels.available;
      const quantity=form.querySelector('[name="quantity"]');
      if(quantity){if(entry?.tracked&&entry.policy==='deny'&&entry.quantity>0){quantity.max=entry.quantity;if(Number(quantity.value)>entry.quantity)quantity.value=entry.quantity}else quantity.removeAttribute('max')}
      const sizeIndex=optionNames.findIndex(name=>/size/i.test(name));
      const size=sizeIndex>=0?current?.options[sizeIndex]:null;
      productRoot.querySelectorAll('.ls-description-accordions li,.product-description li').forEach(li=>{
        if(li.closest('[data-listing-variant]'))return;
        const label=li.querySelector('strong');if(!label)return;const key=label.textContent.replace(':','').trim().toLowerCase();let value=null;
        if(['set includes','pack','pack size'].includes(key))value=summary.included;
        if(['age','age group','age range','suitable age','age/size'].includes(key)&&size)value=size;
        if(['jhabla style','style'].includes(key)&&summary.style)value=summary.style;
        if(value)li.replaceChildren(label,document.createTextNode(' '+value));
      });
      if(changeImage){
       if(current){const u=new URL(location.href);u.searchParams.set('variant',current.id);history.replaceState({},'',u)}
       const gallery=productRoot.querySelector('ls-premium-gallery');
       if(gallery?.selectVariant)gallery.selectVariant(current,content);
       else if(gallery)customElements.whenDefined('ls-premium-gallery').then(()=>gallery.selectVariant(current,listingContent[current?.id]||{}));
      }
    };
    choices.forEach(r=>r.addEventListener('change',()=>update(true)));update(true);
    window.addEventListener('pageshow',()=>update(true));
    form.addEventListener('submit',async event=>{
      if(!current?.available){event.preventDefault();return}
      if(event.submitter!==buy)return;
      event.preventDefault();if(!form.reportValidity())return;
      buy.disabled=true;add.disabled=true;
      const errorNode=productRoot.querySelector('[data-purchase-error]');errorNode.hidden=true;
      try{const root=window.Shopify?.routes?.root||'/';const response=await fetch(root+'cart/add.js',{method:'POST',headers:{'Accept':'application/json'},body:new FormData(form)});const data=await response.json();if(!response.ok)throw Error(data.description||labels.error);location.assign(root+'checkout')}catch(error){errorNode.textContent=error.message;errorNode.hidden=false;update()}
    });
    const sticky=productRoot.querySelector('[data-mobile-sticky-atc]');
    if(sticky&&add)new IntersectionObserver(entries=>sticky.hidden=entries[0].isIntersecting,{threshold:.1}).observe(add);
    stickyAdd?.addEventListener('click',()=>add.click());
  }
});

